import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { api } from "../../core"

type BlockUserForms = {
  userId: string
}

export const BlockUserForm = (props: { firebase: User }) => {
  const form = useForm<BlockUserForms>({
    mode: "onBlur",
    defaultValues: {
      userId: "",
    },
  })
  const { isSubmitting } = form.formState

  const onCreate = async (value: BlockUserForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.POST("/api/v2/users/me/block-users/{user_id}", {
        params: { path: { user_id: value.userId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  const onDelete = async (value: BlockUserForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/users/me/block-users/{user_id}", {
        params: { path: { user_id: value.userId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <div className="form-floating">
          <input className="form-control" {...form.register("userId")} disabled={isSubmitting} />
          <label>User ID</label>
        </div>

        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onCreate)}>
          Block user
        </button>

        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onDelete)}>
          Unblock user
        </button>
      </form>
    </>
  )
}
